import { ValidationErrors, ValidatorFn, FormGroup } from '@angular/forms';


export const validarDv = (field1: string, field2: string): ValidatorFn => {
  return (control: FormGroup): ValidationErrors | null => {
    const nit = control.controls[field1].value;
    const cod = +(control.controls[field2].value);

    return nit && cod && calcularDv(nit.trim()) !== cod ? { identityRevealed: true } : null;
  };
};


export function calcularDv(nit: string) {

  let x: number = 0;
  let y: number = 0;
  let dv: number = 0;
  let z: number = nit.length;


  const arreglo = [3, 7, 13, 17, 19, 23, 29, 37, 41, 43, 47, 53, 59, 67, 71];

  for (let i = 0; i < z; i++) {

    y = +nit.substring(z - i - 1, z - i);
    x += y * arreglo[i];
  };

  y = x % 11;

  if (y > 1) {
    dv = 11 - y;
  } else {
    dv = y;
  }

  return dv;
};





